import { createSlice } from "@reduxjs/toolkit";
import { AppRecord, AppRecordStatus } from "models/appRecord";

interface HeaderSlice {
  isDialogCreateShopOpen: boolean;
  isDialogSeeMorePagesOpen: boolean;
  isLoadingIsSwitchPage: boolean;
  listFriendsUser: any;
  songs: any;
  posts: any;
  hashtags: any;
  friendUsers: any;
  searchTextInput: any;
  friendUserState: AppRecord;
  indexs: any;
  indexTimeSheet: any;
  indexProductservicse: any;
  isHidden: boolean;
  check: boolean;
  btnToggle: boolean;
  btnToggleProduct: boolean;
  bntSearch: boolean;
  btnSearchProduct: boolean;
  btnSearchStaff: boolean;
}

const initialState: HeaderSlice = {
  btnSearchStaff: false,
  bntSearch: false,
  btnSearchProduct: false,
  btnToggle: false,
  btnToggleProduct: false,
  check: false,
  indexs: null,
  indexTimeSheet: null,
  indexProductservicse: null,
  isDialogCreateShopOpen: false,
  isDialogSeeMorePagesOpen: false,
  isLoadingIsSwitchPage: false,
  listFriendsUser: [],
  songs: null,
  posts: null,
  hashtags: null,
  friendUsers: null,
  searchTextInput: "",
  friendUserState: {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  },
  isHidden: false,
};

const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setIsDialogCreateShopOpen(state, action) {
      state.isDialogCreateShopOpen = action.payload;
    },
    setIsDialogSeeMorePagesOpen(state, action) {
      state.isDialogSeeMorePagesOpen = action.payload;
    },
    setIsLoadingIsSwitchPage(state, action) {
      state.isLoadingIsSwitchPage = action.payload;
    },
    setListFriendsUser(state, action) {
      state.listFriendsUser = action.payload;
    },
    setSongs(state, action) {
      state.songs = action.payload;
    },
    setPosts(state, action) {
      state.posts = action.payload;
    },
    setHashtags(state, action) {
      state.hashtags = action.payload;
    },
    setFriendUsers(state, action) {
      state.friendUsers = action.payload;
    },
    appendFriendUsers(state, action) {
      state.friendUsers = [...state.friendUsers, ...action.payload];
    },
    setSearchTextInput(state, action) {
      state.searchTextInput = action.payload;
    },
    setFriendLoading(state, action) {
      state.friendUserState = action.payload;
    },
    setIndexs(state, action) {
      state.indexs = action.payload;
    },
    setIndexTimeSheet(state, action) {
      state.indexTimeSheet = action.payload;
    },
    setIndexProductservicse(state, action) {
      state.indexProductservicse = action.payload;
    },
    setIsHidden(state, action) {
      state.isHidden = action.payload;
    },
    setCheck(state, action) {
      state.check = action.payload;
    },
    setBtnToggle(state, action) {
      state.btnToggle = action.payload;
    },
    setBtnToggleProduct(state, action) {
      state.btnToggleProduct = action.payload;
    },
    setBtnSearch(state, action) {
      state.bntSearch = action.payload;
    },
    setBtnSearchProduct(state, action) {
      state.btnSearchProduct = action.payload;
    },
    setBtnSearchStaff(state, action) {
      state.btnSearchStaff = action.payload;
    },
  },
});

export const {
  setBtnSearchStaff,
  setBtnSearchProduct,
  setBtnSearch,
  setBtnToggleProduct,
  setIsDialogCreateShopOpen,
  setIsDialogSeeMorePagesOpen,
  setIsLoadingIsSwitchPage,
  setListFriendsUser,
  setSongs,
  setPosts,
  setHashtags,
  setFriendUsers,
  setSearchTextInput,
  setFriendLoading,
  setIndexs,
  setIsHidden,
  setIndexTimeSheet,
  setIndexProductservicse,
  appendFriendUsers,
  setCheck,
  setBtnToggle,
} = headerSlice.actions;

const headerReducer = headerSlice.reducer;
export default headerReducer;
